import dayjs from 'dayjs';
import { IHistory } from '../interface';

const CHART_PROP = [
    {
        primaryColor: 'rgb(53, 162, 235)',
        secondaryColor: 'rgba(219, 86, 43, 0.2)',
    },
    {
        primaryColor: 'rgb(255, 99, 132)',
        secondaryColor: 'rgba(255, 99, 132, 0.5)',
        dash: 5,
    },
    {
        primaryColor: 'rgb(21, 198, 193)',
        secondaryColor: 'rgba(21, 198, 193, 0.5)',
    },
    {
        primaryColor: 'rgb(21, 198, 193)',
        secondaryColor: 'rgba(21, 198, 193, 0.5)',
        dash: 5,
    },
];

export const getDefaultProperties = (i: number) => ({
    borderColor: CHART_PROP[i].primaryColor,
    pointBackgroundColor: CHART_PROP[i].primaryColor,
    pointBorderWidth: 0,
    datalabels: {
        color: CHART_PROP[i].primaryColor,
        align: 'bottom',
    },
    borderDash: [CHART_PROP[i].dash],
});

export const reCalculateHistory = (
    histories: IHistory[] = [],
    unit?: number
): IHistory[] => {
    return (
        histories?.map((item) => {
            return {
                ...item,
                times: (unit
                    ? item.times?.map((time: any) => {
                          for (const [key, value] of Object.entries(time)) {
                              if (typeof value === 'number') {
                                  time[key] = value / unit;
                              }
                          }
                          return time;
                      })
                    : item.times
                ).sort(
                    (a, b) =>
                        dayjs(a['time'], 'HH:mm').valueOf() -
                        dayjs(b['time'], 'HH:mm').valueOf()
                ),
            } as IHistory;
        }) || ([] as IHistory[])
    );
};

export const checkZero = (data = []) => {
    const isZero = data.every((item) => item === 0);
    return isZero ? [] : data;
};
